import React, {FC} from 'react';

import {NON_PRESCRIPTION, PRESCRIPTION_METHOD} from 'constants/product';
import {
    useDescription,
    usePrismContent,
    useUsage,
} from 'desktop/components/cartItemHelper/cartItemHelper';
import {CheckoutItemType} from 'desktop/types/checkoutItemsType';

import {CartItemDetailsRowV2} from '../cartItemDetailsRowV2/cartItemDetailsRowV2';
import {CartItemUpgradesRow} from '../cartItemUpgradesRow/cartItemUpgradesRow';

import {SendPrescriptionLater} from '../sendPrescriptionLater/sendPrescriptionLater';

import s from './glassesCartItemDetails.scss';

type PropsType = {
    item: CheckoutItemType;
};

/**
 * Cart collapsible content
 * @constructor
 */
export const GlassesCartItemDetails: FC<PropsType> = ({item}) => {
    const usage = useUsage(item);
    const prismContent = usePrismContent(item);
    const description = useDescription(item, item.product.type);

    return (
        <div className={s.wrapper}>
            <CartItemDetailsRowV2
                title={
                    <>
                        <span data-test-name="color">{item.product.color}</span>
                        {item.product.size && (
                            <span data-test-name="frameSize">, {item.product.size}</span>
                        )}
                    </>
                }
                dataTestName="frameInfo"
                label="Frame:"
                price={item.product.price}
                specialPrice={item.product.finalPrice}
            />
            {usage && (
                <CartItemDetailsRowV2
                    dataTestName="useGlassesFor"
                    dataTestValue={usage.title}
                    description={description}
                    label="Lens:"
                    postfix={prismContent}
                    prescription={item.prescription}
                    price={usage.price}
                    specialPrice={usage.finalPrice}
                    title={usage.sku === NON_PRESCRIPTION ? usage.usageName : usage.title}
                />
            )}
            <CartItemUpgradesRow options={item.options} />
            {item.prescription?.method === PRESCRIPTION_METHOD.SEND_EMAIL_OR_FAX_METHOD && (
                <SendPrescriptionLater className={s.sendPrescription} withFax={false} />
            )}
        </div>
    );
};
